import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useGetStep } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useProgressInfoTitle } from 'pages/settings/pages/numbers/pages/BuyNumber/hooks/useProgressInfoTitle'
import { useBuyNumberStepsContext } from '../context/useBuyNumberStepsContext'
import { type BuyNumberRoutesSteps } from '../store/BuyNumberStepsStore'

export const BuyNumberStepsLayout = observer(() => {
  const { numbersLayerStore, allStepsLength, decreaseStep, setCurrentStep, getSettingsStep } =
    useBuyNumberStepsContext()
  const settingsStep = useGetStep<BuyNumberRoutesSteps>(getSettingsStep)
  const infoTitle = useProgressInfoTitle()

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep])

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title='Buy number'
      settingsStep={settingsStep}
      closeSetting={numbersLayerStore.redirectToRoot}
      decreaseStep={decreaseStep}
    />
  )
})
